import { getCSRFToken } from '@eventbrite/http';
import { EVENT_DEFAULT_ERROR_MESSAGE } from '../constants';
import { fetchV3WithTranslateServerErrors } from './base';
import { _getGenerateGuestTokenUrl } from './constants';

/**
 * How to handle errors on the event lifecycle
 */
const ERROR_SPEC = {
    default: () => EVENT_DEFAULT_ERROR_MESSAGE,
};

/**
 * Return a Promise which is either a resolved Promise that returns
 * an empty object or a `fetch` Promise which returns an object with
 * the key `guest_token` and value is an associated signed guest
 * token.
 */
export const generateGuestToken = async (eventId: string) => {
    if (getCSRFToken()) {
        return {
            response: {},
            headers: {},
        };
    }

    // No CSRFToken cookie is present. This means we're in a
    // browser that won't let us set cookies.

    const { response, headers } = await fetchV3WithTranslateServerErrors<{
        guest_token: string;
    }>(ERROR_SPEC, _getGenerateGuestTokenUrl(), {
        method: 'POST',
        body: JSON.stringify({ event_id: eventId }),
    });

    return { response, headers };
};
